export const Venue_Type = "Venue Type";
export const Country_Code = "Country Code";
export const Venue_Country = "Venue Country";
export const Venue_State = "Venue State";
export const Venue_City = "Venue City";
export const Select = "Select";


export const VM_transformCountryList = (countries) =>
    countries.map((country) => ({
      id: country.cid,
      label: country.country_name,
      value: country.cid,
}));
export const VM_transformCountryCurrencyList = (countries) =>
    countries.map((country) => ({
      id: country.cid,
      label: country.country_name,
      value: country.country_code,
}));

export const VM_transformStatesList = (states) =>
  states.map((state) => ({
    id: state.id,
    label: state.state,
    value: state.id,
  })) ;

  export const VM_transformCountryCitiesList = (citiesList) =>
    citiesList.map((item) => ({
      id: item.id,
      label: item.city,
      value: item.id,
  }));

export const  getCurrencyFromCountryID = (countryList, c_id) => {
  if (!Array.isArray(countryList) || !c_id) return null;

  const foundCountry = countryList.find(
    (item) => item.cid === c_id
  );

  return foundCountry ? foundCountry.currency_code : null;
}

export const getCountryCodeFromCountryID = (countryList, c_id) => {
  if (!Array.isArray(countryList) || !c_id) return null;

  const foundCountry = countryList.find(
    (item) => item.cid === c_id
  );

  return foundCountry ? foundCountry.country_code : null;
}
export const VM_venueTypes = [
    { id: 1, label: 'Convention Hall', value: 'Convention Hall' },
    { id: 2, label: 'Banquet Hall', value: 'Banquet Hall' },
    { id: 3, label: 'Function Hall', value: 'Function Hall' },
    { id: 4, label: 'Resort', value: 'Resort' },
    { id: 5, label: 'Farm house', value: 'Farm house' },
    { id: 6, label: 'Club House', value: 'Club House' },
    { id: 7, label: 'Open Lawn', value: 'Open Lawn' },
    { id: 8, label: 'Others', value: 'Others' },
  ];

export const VM_sub_venueTypes = [
    // { id: 1, label: 'Select', value: 'Select' }, 
    { id: 2, label: 'Hall', value: 'Hall' },
    { id: 3, label: 'Lawn', value: 'Lawn' },
    { id: 4, label: 'Others', value: 'Others' },
  ];

export const returnLabelBySelectName = (name,option) => {
   let label=''; 
    switch(name){
        case Venue_Type     :  label = `${option.label}`;    break;
        case Country_Code   :  label = `${option.value}`;    break;
        case Venue_Country  :  label = `${option.la}`;    break;
        default             :   break;
    }
   return label; 
}
